if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      console.log('VariantSelects constructor called for element:', this);
      console.log('Element ID:', this.id);
      console.log('Element dataset:', this.dataset);
      
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.hasGenderSwitch = this.dataset.hasGenderSwitch === 'true';
      this.currentGender = null; // No forzar género aquí, lo detectaremos después
      
      console.log('Gender switch enabled:', this.hasGenderSwitch);
      
      // Debug: verificar si este elemento tiene el script JSON
      const hasJsonScript = !!this.querySelector('[type="application/json"]');
      console.log('Has JSON script in this element:', hasJsonScript);
      
      this.addEventListener('change', this.onVariantChange);
      
      // VALIDACIÓN AGREGADA - verificar que existan otros selectors
      const allSelectors = document.querySelectorAll('variant-selects');
      this.other = Array.from(allSelectors).filter((selector) => {
        return selector != this;
      });
      console.log('Found', allSelectors.length, 'variant-selects elements total');

      // VALIDACIÓN AGREGADA - verificar que el productWrapper existe
      this.productWrapper = this.closest('.thb-product-detail');
      if (!this.productWrapper) {
        console.warn('VariantSelects: productWrapper no encontrado');
        return;
      }
      
      // VALIDACIÓN AGREGADA - verificar que el productSlider existe
      this.productSlider = this.productWrapper.querySelector('.product-images');
      if (!this.productSlider) {
        console.warn('VariantSelects: productSlider no encontrado');
      }
      
      this.hideVariants = this.dataset.hideVariants === 'true';
      
      // Inicializar switch de género si existe
      if (this.hasGenderSwitch) {
        console.log('Initializing gender switch functionality');
        this.initGenderSwitch();
        this.loadGenderData();
        this.hideOriginalGenderOptions();
      }
    }

    connectedCallback() {
      // Filtrar talles según género inicial si aplica
      if (this.hasGenderSwitch) {
        console.log('Has gender switch - determining initial gender based on current variant');
        
        // Detectar el género correcto basado en la variante actual
        this.detectInitialGender();
        
        // Asegurar que el botón correcto esté activo
        const genderButtons = this.querySelectorAll('.gender-switch-btn');
        genderButtons.forEach(btn => {
          if (btn.dataset.gender === this.currentGender) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });
        
        // Filtrar ANTES de updateOptions para no interferir
        setTimeout(() => {
          this.filterSizesByGender();
          
          // Después del filtrado, actualizar todo
          setTimeout(() => {
            this.updateOptions();
            this.updateMasterId();
            this.setDisabled();
            this.setImageSet();
          }, 50);
        }, 100);
      } else {
        // Si no hay gender switch, proceder normalmente
        this.updateOptions();
        this.updateMasterId();
        this.setDisabled();
        this.setImageSet();
      }
    }

    // NUEVO MÉTODO: Inicializar switch de género
    initGenderSwitch() {
      const genderButtons = this.querySelectorAll('.gender-switch-btn');
      
      if (genderButtons.length === 0) {
        console.warn('Gender switch buttons not found');
        return;
      }
      
      console.log('Initializing gender switch with', genderButtons.length, 'buttons');
      
      // No forzar el estado inicial aquí, se determinará en detectInitialGender
      
      genderButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          
          console.log('Gender button clicked:', button.dataset.gender);
          
          // Marcar que estamos cambiando género
          this.changingGender = true;
          
          // Remover clase active de todos los botones
          genderButtons.forEach(btn => btn.classList.remove('active'));
          
          // Agregar clase active al botón clickeado
          button.classList.add('active');
          
          // Actualizar género actual
          this.currentGender = button.dataset.gender;
          console.log('Current gender updated to:', this.currentGender);
          
          // Filtrar talles según nuevo género
          this.filterSizesByGender();
          
          // Actualizar variante si es necesario
          this.updateVariantAfterGenderChange();
          
          // Liberar la flag después de un momento
          setTimeout(() => {
            this.changingGender = false;
          }, 200);
        });
      });
    }

    // NUEVO MÉTODO: Detectar género inicial basado en variante actual
    detectInitialGender() {
      if (!this.tallesData) {
        console.warn('No talles data available for gender detection');
        this.currentGender = 'hombre'; // fallback
        return;
      }
      
      // Obtener el talle actualmente seleccionado
      const currentSize = this.getCurrentSelectedSize();
      
      if (currentSize) {
        console.log('Current selected size:', currentSize);
        
        // Verificar en qué género está este talle
        if (this.tallesData.mujer && this.tallesData.mujer.includes(currentSize)) {
          this.currentGender = 'mujer';
          console.log('Detected gender: mujer (based on size', currentSize, ')');
        } else if (this.tallesData.hombre && this.tallesData.hombre.includes(currentSize)) {
          this.currentGender = 'hombre';
          console.log('Detected gender: hombre (based on size', currentSize, ')');
        } else {
          // Si no está en ninguno, usar hombre por defecto
          this.currentGender = 'hombre';
          console.log('Size not found in any gender, defaulting to hombre');
        }
      } else {
        // Si no hay talle seleccionado, usar hombre por defecto
        this.currentGender = 'hombre';
        console.log('No size selected, defaulting to hombre');
      }
    }

    // NUEVO MÉTODO: Seleccionar una variante válida para el género actual
    selectValidVariantForGender() {
      if (!this.tallesData || !this.currentGender) return;
      
      const availableSizes = this.tallesData[this.currentGender] || [];
      if (availableSizes.length === 0) return;
      
      console.log('Selecting valid variant for gender:', this.currentGender, 'Available sizes:', availableSizes);
      
      // Obtener todas las variantes
      const variantData = this.getVariantData();
      if (!variantData) return;
      
      console.log('Total variants available:', variantData.length);
      
      // Buscar una variante que tenga un talle disponible para este género
      const validVariant = variantData.find(variant => {
        // Verificar en todas las opciones posibles (option1, option2, option3)
        const option1 = variant.option1 || variant.options[0];
        const option2 = variant.option2 || variant.options[1];
        const option3 = variant.option3 || variant.options[2];
        
        console.log('Checking variant:', variant.id, 'Options:', option1, option2, option3, 'Available:', variant.available);
        
        // Verificar si alguna de las opciones coincide con los talles disponibles
        const hasValidSize = availableSizes.includes(option1) || 
                            availableSizes.includes(option2) || 
                            availableSizes.includes(option3);
        
        return hasValidSize && variant.available;
      });
      
      if (validVariant) {
        console.log('Found valid variant:', validVariant);
        
        // Determinar cuál opción contiene el talle
        const option1 = validVariant.option1 || validVariant.options[0];
        const option2 = validVariant.option2 || validVariant.options[1];
        const option3 = validVariant.option3 || validVariant.options[2];
        
        let targetSize = null;
        if (availableSizes.includes(option1)) targetSize = option1;
        else if (availableSizes.includes(option2)) targetSize = option2;
        else if (availableSizes.includes(option3)) targetSize = option3;
        
        if (targetSize) {
          console.log('Target size determined:', targetSize);
          
          // Actualizar el talle seleccionado
          const sizeFieldset = this.findSizeFieldset();
          if (sizeFieldset) {
            // Actualizar select o radio button
            const select = sizeFieldset.querySelector('select');
            if (select) {
              select.value = targetSize;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              const targetInput = sizeFieldset.querySelector(`input[value="${targetSize}"]`);
              if (targetInput) {
                // Desmarcar todos primero
                sizeFieldset.querySelectorAll('input').forEach(inp => inp.checked = false);
                // Marcar el correcto
                targetInput.checked = true;
                targetInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            
            console.log('Updated size selection to:', targetSize);
          }
        }
      } else {
        console.warn('No valid variant found for gender:', this.currentGender);
        console.log('Available variants:', variantData.map(v => ({
          id: v.id,
          options: [v.option1 || v.options[0], v.option2 || v.options[1], v.option3 || v.options[2]],
          available: v.available
        })));
      }
    }
    getCurrentSelectedSize() {
      const sizeFieldset = this.findSizeFieldset();
      if (!sizeFieldset) return null;
      
      // Buscar en select
      const select = sizeFieldset.querySelector('select');
      if (select && select.value) {
        return select.value.trim();
      }
      
      // Buscar en radio buttons
      const checkedInput = sizeFieldset.querySelector('input:checked');
      if (checkedInput && checkedInput.value) {
        return checkedInput.value.trim();
      }
      
      return null;
    }
    hideOriginalGenderOptions() {
      // Buscar fieldsets que contengan opciones de género
      const fieldsets = this.querySelectorAll('fieldset');
      
      fieldsets.forEach(fieldset => {
        const label = fieldset.querySelector('.form__label');
        if (label) {
          const labelText = label.textContent.toLowerCase();
          
          // Si el fieldset contiene opciones de género, ocultarlo
          if (labelText.includes('genero') || labelText.includes('género') || labelText.includes('gender')) {
            fieldset.style.display = 'none';
            console.log('Hidden original gender fieldset:', labelText);
            return;
          }
        }
        
        // También revisar si el fieldset tiene opciones como "Hombre/Mujer"
        const inputs = fieldset.querySelectorAll('input');
        const hasGenderOptions = Array.from(inputs).some(input => {
          const value = input.value.toLowerCase();
          return value.includes('hombre') || value.includes('mujer') || 
                 value.includes('male') || value.includes('female') ||
                 value.includes('homme') || value.includes('femme');
        });
        
        if (hasGenderOptions) {
          fieldset.style.display = 'none';
          console.log('Hidden fieldset with gender options');
        }
      });
    }
    loadGenderData() {
      const tallesDataScript = document.getElementById(`talles-data-${this.dataset.section}`);
      if (tallesDataScript) {
        try {
          this.tallesData = JSON.parse(tallesDataScript.textContent);
          console.log('Talles data loaded:', this.tallesData);
        } catch (e) {
          console.error('Error parsing talles data:', e);
          this.tallesData = null;
        }
      } else {
        console.warn('Talles data script not found for section:', this.dataset.section);
      }
    }

    // NUEVO MÉTODO: Filtrar talles por género
    filterSizesByGender() {
      if (!this.tallesData || !this.currentGender) {
        console.warn('Cannot filter sizes - missing data:', {
          tallesData: !!this.tallesData,
          currentGender: this.currentGender
        });
        return;
      }
      
      const availableSizes = this.tallesData[this.currentGender] || [];
      console.log('Filtering sizes for gender:', this.currentGender, 'Available sizes:', availableSizes);
      
      if (availableSizes.length === 0) {
        console.warn('No sizes available for gender:', this.currentGender);
        return;
      }
      
      // Encontrar el fieldset de talle
      const sizeFieldset = this.findSizeFieldset();
      if (!sizeFieldset) {
        console.warn('Size fieldset not found');
        return;
      }
      
      console.log('Size fieldset found:', sizeFieldset);
      
      // Filtrar opciones según género
      if (sizeFieldset.querySelector('select')) {
        // Para dropdown
        console.log('Filtering dropdown options');
        const select = sizeFieldset.querySelector('select');
        const options = select.querySelectorAll('option');
        let visibleCount = 0;
        
        options.forEach(option => {
          if (option.value === '') return; // Skip empty option
          
          const isAvailable = availableSizes.includes(option.value.trim());
          option.style.display = isAvailable ? '' : 'none';
          
          if (isAvailable) visibleCount++;
          
          console.log('Option:', option.value.trim(), 'Available:', isAvailable);
        });
        
        console.log('Total visible options:', visibleCount);
        
        // Si la opción seleccionada no está disponible, seleccionar la primera disponible
        if (!availableSizes.includes(select.value.trim()) && availableSizes.length > 0) {
          const firstAvailableOption = Array.from(options).find(option => 
            option.value !== '' && availableSizes.includes(option.value.trim())
          );
          if (firstAvailableOption) {
            select.value = firstAvailableOption.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        
      } else if (sizeFieldset.querySelectorAll('input').length) {
        // Para radio buttons o checkboxes
        console.log('Filtering radio/checkbox options');
        const inputs = sizeFieldset.querySelectorAll('input');
        let hasValidSelection = false;
        let visibleCount = 0;
        
        inputs.forEach(input => {
          const isAvailable = availableSizes.includes(input.value.trim());
          
          // Estrategia alternativa: modificar el input y elementos relacionados directamente
          if (isAvailable) {
            // Mostrar el input y elementos relacionados
            input.style.display = '';
            input.style.visibility = 'visible';
            input.removeAttribute('disabled');
            
            // Buscar y mostrar el texto/label asociado
            const nextSibling = input.nextElementSibling;
            if (nextSibling) {
              nextSibling.style.display = '';
              nextSibling.style.visibility = 'visible';
            }
            
            // Buscar el contenedor label si existe
            const labelContainer = input.closest('label');
            if (labelContainer) {
              labelContainer.style.display = 'block';
              labelContainer.style.visibility = 'visible';
            }
            
            // Buscar elementos con clases específicas de Shopify
            const sizeElement = document.querySelector(`[data-value="${input.value}"]`);
            if (sizeElement) {
              sizeElement.style.display = 'block';
              sizeElement.style.visibility = 'visible';
            }
            
            visibleCount++;
          } else {
            // Ocultar el input y elementos relacionados
            input.style.display = 'none';
            input.style.visibility = 'hidden';
            
            // Ocultar el texto/label asociado
            const nextSibling = input.nextElementSibling;
            if (nextSibling) {
              nextSibling.style.display = 'none';
              nextSibling.style.visibility = 'hidden';
            }
            
            // Ocultar el contenedor label si existe
            const labelContainer = input.closest('label');
            if (labelContainer) {
              labelContainer.style.display = 'none';
              labelContainer.style.visibility = 'hidden';
            }
            
            // Ocultar elementos con clases específicas de Shopify
            const sizeElement = document.querySelector(`[data-value="${input.value}"]`);
            if (sizeElement) {
              sizeElement.style.display = 'none';
              sizeElement.style.visibility = 'hidden';
            }
          }
          
          console.log('Input:', input.value.trim(), 'Available:', isAvailable, 'Checked:', input.checked, 'Display:', input.style.display);
          
          // Si este input estaba seleccionado pero ya no está disponible
          if (input.checked && !isAvailable) {
            input.checked = false;
            console.log('Unchecked unavailable input:', input.value.trim());
          } else if (input.checked && isAvailable) {
            hasValidSelection = true;
            console.log('Valid selection maintained:', input.value.trim());
          }
        });
        
        console.log('Total visible inputs:', visibleCount, 'Has valid selection:', hasValidSelection);
        
        // Si no hay selección válida, seleccionar el primer talle disponible
        if (!hasValidSelection && availableSizes.length > 0) {
          const firstAvailable = Array.from(inputs).find(input => 
            availableSizes.includes(input.value.trim())
          );
          if (firstAvailable) {
            firstAvailable.checked = true;
            console.log('Auto-selected first available size:', firstAvailable.value);
            firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }

    // NUEVO MÉTODO: Encontrar el fieldset de talle
    findSizeFieldset() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      
      // Buscar por nombres comunes de talle
      const sizeKeywords = ['size', 'talle', 'talla', 'sizes'];
      
      // Primero buscar por label
      let sizeFieldset = fieldsets.find(fieldset => {
        const label = fieldset.querySelector('.form__label');
        if (label) {
          const labelText = label.textContent.toLowerCase();
          return sizeKeywords.some(keyword => labelText.includes(keyword));
        }
        return false;
      });
      
      // Si no encuentra por label, buscar fieldsets que NO sean de color
      if (!sizeFieldset) {
        const colorKeywords = ['color', 'colour', 'couleur', 'farbe'];
        sizeFieldset = fieldsets.find(fieldset => {
          const label = fieldset.querySelector('.form__label');
          if (label) {
            const labelText = label.textContent.toLowerCase();
            return !colorKeywords.some(keyword => labelText.includes(keyword));
          }
          return true; // Si no tiene label, asumir que es talle
        });
      }
      
      // Como último recurso, usar el último fieldset
      return sizeFieldset || fieldsets[fieldsets.length - 1];
    }

    // NUEVO MÉTODO: Actualizar variante después de cambio de género
    updateVariantAfterGenderChange() {
      console.log('updateVariantAfterGenderChange called');
      
      // Actualizar opciones y variante
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantText();
      
      // Verificar si tenemos una variante válida
      if (this.currentVariant) {
        console.log('Current variant after gender change:', this.currentVariant.id);
      } else {
        console.warn('No current variant found after gender change, attempting to find valid variant');
        // Si no hay variante actual, intentar seleccionar una válida
        this.selectValidVariantForGender();
        
        // Después de intentar seleccionar, verificar nuevamente
        setTimeout(() => {
          this.updateOptions();
          this.updateMasterId();
          
          if (this.currentVariant) {
            console.log('Valid variant found after selection:', this.currentVariant.id);
            this.updateMedia();
            if (this.updateUrl) {
              this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductInfo();
          } else {
            console.error('Still no valid variant found');
          }
        }, 100);
      }
      
      // Si ya tenemos variante, proceder normalmente
      if (this.currentVariant) {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }
      
      // Llamar a setDisabled al final, después de que todo esté configurado
      setTimeout(() => {
        this.setDisabled();
      }, 150);
      
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
        gender: this.currentGender
      });
    }

    onVariantChange() {
      console.log('onVariantChange triggered');
      
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      
      // Solo llamar setDisabled si no estamos en medio de un cambio de género
      if (!this.changingGender) {
        this.setDisabled();
      }

      if (!this.currentVariant) {
        console.log('No current variant found');
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        console.log('Current variant found:', this.currentVariant.id);
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
        gender: this.currentGender
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          let checked = fieldset.querySelector('input:checked');
          if (!checked) {
            const fallback = fieldset.querySelector('input:not([disabled])') || fieldset.querySelector('input');
            if (fallback) {
              fallback.checked = true;
              checked = fallback;
            }
          }
          if (checked) {
            this.options.push(checked.value);
          }
        }
      });
    }
    
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    
    // MÉTODO MEJORADO updateMasterId
    updateMasterId() {
      const variantData = this.getVariantData();
      if (!variantData || !Array.isArray(variantData)) {
        console.warn('VariantSelects: Datos de variantes no válidos');
        this.currentVariant = null;
        return;
      }
      
      this.currentVariant = variantData.find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      if (!productSlider) return;
      
      let activeMedia = productSlider.querySelector(mediaId);
      if (productSlider.flkty && this.hideVariants) {

        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        if (activeMedia) {
          activeMedia.classList.add('is-active');
          activeMedia.classList.add('is-initial-selected');
        }

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.flkty.selectCell(mediaId);

      } else if (productSlider.flkty) {
        productSlider.flkty.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input && this.currentVariant) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--mobile`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      if (!this.currentVariant) return;
      
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        const submitButtonBold = submitButtonText ? submitButtonText.querySelector('b, strong') : null;

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            if (submitButtonBold) {
              submitButtonBold.textContent = text;
            } else {
              submitButtonText.textContent = text;
            }
          }
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButton.classList.remove('sold-out');

          if (productTemplate?.includes('pre-order')) {
            if (submitButtonBold) {
              submitButtonBold.textContent = window.theme.variantStrings.preOrder;
            } else {
              submitButtonText.textContent = window.theme.variantStrings.preOrder;
            }
          } else {
            if (submitButtonBold) {
              submitButtonBold.textContent = window.theme.variantStrings.addToCart;
            } else {
              submitButtonText.textContent = window.theme.variantStrings.addToCart;
            }
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_mobile = document.getElementById(`price-${this.dataset.section}--mobile`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
      if (price_mobile) price_mobile.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data && Array.isArray(variant_data)) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        let imageSetInput = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]');
        if (imageSetInput) {
          this.imageSetIndex = imageSetInput.dataset.index;
          this.dataset.imageSetIndex = this.imageSetIndex;
          this.setImageSetMedia();
        }
      }
    }
    
    setImageSetMedia() {
      if (!this.imageSetIndex || !this.currentVariant) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    // MÉTODO MEJORADO getVariantData
    getVariantData() {
      const isValidVariantArray = (data) => {
        return Array.isArray(data) && data.length > 0 &&
          data[0] && typeof data[0] === 'object' &&
          data[0].hasOwnProperty('id') &&
          data[0].hasOwnProperty('available') &&
          data[0].hasOwnProperty('options');
      };

      if (isValidVariantArray(this.variantData)) {
        return this.variantData;
      }

      // Cache inválido (p.ej. otro JSON del AJAX) — forzar relectura
      this.variantData = null;

      let jsonScript = this.querySelector('.product-variants-json')
        || document.getElementById(`product-variants-${this.dataset.section}`);

      if (!jsonScript) {
        jsonScript = this.querySelector('[type="application/json"]');
      }

      if (!jsonScript && this.productWrapper) {
        jsonScript = this.productWrapper.querySelector('.product-variants-json')
          || this.productWrapper.querySelector('variant-selects [type="application/json"]');
      }

      if (!jsonScript) {
        const allJsonScripts = document.querySelectorAll('script[type="application/json"]');
        jsonScript = Array.from(allJsonScripts).find(script => {
          try {
            return isValidVariantArray(JSON.parse(script.textContent));
          } catch (e) {
            return false;
          }
        });
      }

      if (!jsonScript) {
        console.error('VariantSelects: Script JSON de variantes no encontrado');
        return null;
      }

      try {
        const parsed = JSON.parse(jsonScript.textContent);
        if (!isValidVariantArray(parsed)) {
          console.error('VariantSelects: JSON encontrado no es un array de variantes válido');
          return null;
        }
        this.variantData = parsed;
        return this.variantData;
      } catch (e) {
        console.error('VariantSelects: Error parsing JSON de variantes:', e);
        return null;
      }
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const inputs = Array.from(fieldset.querySelectorAll('input'));
        let checked = inputs.find((radio) => radio.checked);
        if (!checked) {
          checked = inputs.find((radio) => !radio.disabled) || inputs[0];
          if (checked) checked.checked = true;
        }
        return checked ? checked.value : '';
      }).filter((value) => value !== '');
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.setupProductGallery);
    }
    
    connectedCallback() {
      // VALIDACIÓN AGREGADA - verificar que el product_container existe
      this.product_container = this.closest('.thb-product-detail');
      if (!this.product_container) {
        console.warn('ProductSlider: product_container no encontrado');
        return;
      }
      
      // VALIDACIÓN AGREGADA - verificar que el thumbnail_container existe
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      if (!this.thumbnail_container) {
        console.warn('ProductSlider: thumbnail_container no encontrado');
        return;
      }
      
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      
      // VALIDACIÓN AGREGADA - verificar que thumbnail_container existe antes de usar querySelectorAll
      if (this.thumbnail_container) {
        this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      } else {
        this.thumbnails = [];
        console.warn('ProductSlider: No se pudieron obtener thumbnails');
      }
      
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        if (active_thumb) {
          active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }

        // Stop previous video
        if (previous_media && previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media && previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        if (!this.sticky) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      }));



      let product_drawer = document.getElementById('Product-Modal');

      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.hide();
      }
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      if (form) observer.observe(form);
      if (footer) observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

// FUNCIÓN MEJORADA PARA EL SWATCHER
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM Content Loaded - Product.js initialized');
  
  function activarSwatchesAgrupados() {
    document.querySelectorAll('.swatch-item').forEach(function(item) {
      // Evitar listeners apilados tras cada swap (doble fetch / doble parpadeo)
      if (item.dataset.lopSwatchBound === 'true') return;
      item.dataset.lopSwatchBound = 'true';

      item.addEventListener('click', function(e) {
        e.preventDefault();
        var handle = this.getAttribute('data-handle');
        if (!handle) return;

        // Ignorar clicks mientras hay un swap en curso
        if (window.__lopSwatchSwapInFlight) return;
        window.__lopSwatchSwapInFlight = true;
        
        // Actualiza la URL del navegador sin recargar (™ y unicode en handles)
        window.history.replaceState(null, '', '/products/' + encodeURIComponent(handle));
        
        // Trae el producto por AJAX
        fetch('/products/' + encodeURIComponent(handle) + '?view=main-ajax')
          .then(response => response.text())
          .then(html => {
            // Crea un DOM temporal para extraer los bloques
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            
            // 1. DESTRUIR elementos existentes antes de reemplazar
            destroyExistingElements();
            
            // 2. Reemplazar contenido
            replaceContent(tempDiv);
            
            // 3. Re-inicializar todo después de un pequeño delay
            setTimeout(() => {
              initializeNewElements(tempDiv);

              if (typeof window.lopReinitPdpMobileGallery === 'function') {
                window.lopReinitPdpMobileGallery('product.js: grouped swatch AJAX (main-ajax)');
              }

              if (typeof window.lopReinitPdpImageLightbox === 'function') {
                window.lopReinitPdpImageLightbox('product.js: grouped swatch AJAX (main-ajax)');
              }

              // Jibbitz / letter pins: reattach tras swap (scripts inline no re-ejecutan)
              if (typeof window.lopReinitJibbitzComplementary === 'function') {
                window.lopReinitJibbitzComplementary();
              }
              if (typeof window.lopInitLetterPinsGenerators === 'function') {
                window.lopInitLetterPinsGenerators();
              }

              document.dispatchEvent(new CustomEvent('product:switched', {
                detail: { handle: handle },
                bubbles: true
              }));
              
              // 4. Detectar y ocultar swatches con placeholder después del reemplazo AJAX
              if (window.lopDetectarSwatchesPlaceholder) {
                window.lopDetectarSwatchesPlaceholder();
              }

              window.__lopSwatchSwapInFlight = false;
            }, 150);
          })
          .catch(error => {
            console.error('Error loading product:', error);
            window.__lopSwatchSwapInFlight = false;
          });
      });
    });
  }

  function destroyExistingElements() {
    // Destruir sliders existentes
    const existingSliders = document.querySelectorAll('product-slider');
    existingSliders.forEach(slider => {
      if (slider.flkty) {
        try {
          slider.flkty.destroy();
        } catch (e) {
          console.warn('Error destroying slider:', e);
        }
      }
    });

    // Limpiar event listeners de variant selects
    const existingVariantSelects = document.querySelectorAll('variant-selects');
    existingVariantSelects.forEach(variantSelect => {
      if (variantSelect.onVariantChange) {
        variantSelect.removeEventListener('change', variantSelect.onVariantChange);
      }
    });
  }

  function replaceContent(tempDiv) {
    // Reemplaza la galería de imágenes
    var newGallery = tempDiv.querySelector('.product-gallery-container');
    var oldGallery = document.querySelector('.product-gallery-container');
    if (newGallery && oldGallery) {
      oldGallery.innerHTML = newGallery.innerHTML;
    }

    // Actualizar data attributes del contenedor principal del producto
    var newProductDetail = tempDiv.querySelector('.thb-product-detail.product');
    var oldProductDetail = document.querySelector('.thb-product-detail.product');
    
    if (newProductDetail && oldProductDetail) {
      // Copiar data attributes de descuento y cucardas del nuevo HTML al contenedor principal
      // IMPORTANTE: También ELIMINAR los atributos si el nuevo producto no los tiene
      var descuento = newProductDetail.getAttribute('data-collection-descuento');
      var cucardaTitulo = newProductDetail.getAttribute('data-collection-cucarda-titulo');
      var cucardaColorTitulo = newProductDetail.getAttribute('data-collection-cucarda-color-titulo');
      var cucardaColorDescuento = newProductDetail.getAttribute('data-collection-cucarda-color-descuento');
      
      // Actualizar o eliminar data-collection-descuento
      if (descuento) {
        oldProductDetail.setAttribute('data-collection-descuento', descuento);
      } else {
        oldProductDetail.removeAttribute('data-collection-descuento');
      }
      
      // Actualizar o eliminar data-collection-cucarda-titulo
      if (cucardaTitulo) {
        oldProductDetail.setAttribute('data-collection-cucarda-titulo', cucardaTitulo);
      } else {
        oldProductDetail.removeAttribute('data-collection-cucarda-titulo');
      }
      
      // Actualizar o eliminar data-collection-cucarda-color-titulo
      if (cucardaColorTitulo) {
        oldProductDetail.setAttribute('data-collection-cucarda-color-titulo', cucardaColorTitulo);
      } else {
        oldProductDetail.removeAttribute('data-collection-cucarda-color-titulo');
      }
      
      // Actualizar o eliminar data-collection-cucarda-color-descuento
      if (cucardaColorDescuento) {
        oldProductDetail.setAttribute('data-collection-cucarda-color-descuento', cucardaColorDescuento);
      } else {
        oldProductDetail.removeAttribute('data-collection-cucarda-color-descuento');
      }
      
      // Limpiar elementos de descuento anteriores para evitar duplicados
      var cucardaAnterior = oldProductDetail.querySelector('.LOP-cucarda-descuento');
      if (cucardaAnterior) {
        cucardaAnterior.remove();
      }
      var preciosDescuentoAnteriores = oldProductDetail.querySelectorAll('.LOP-precios-descuento-container');
      preciosDescuentoAnteriores.forEach(function(el) { el.remove(); });
    }

    // Reemplaza la información de producto PRESERVANDO EL BACKGROUND CONTAINER
    var newInfo = tempDiv.querySelector('.product-information');
    var oldInfo = document.querySelector('.product-information');
    if (newInfo && oldInfo) {
      // Puente visual Jibbitz: el markup SND llega con display:none y cards vacías.
      // Sin puente el bloque parpadea/desaparece hasta que alguien vuelva a revelarlo.
      var prevComplementary = oldInfo.querySelector('.complementary-element');
      var prevWasVisible = !!(
        prevComplementary &&
        getComputedStyle(prevComplementary).display !== 'none'
      );
      var prevRec = prevComplementary && prevComplementary.querySelector('product-recommendations');
      var prevPool = prevComplementary && prevComplementary.querySelector('.lop-complementary-jibbitz-pool');
      var bridgeRecHtml = prevRec && prevRec.querySelector('a[href*="/products/"]') ? prevRec.innerHTML : '';
      var bridgePoolHtml = prevPool && prevPool.querySelector('.lop-jibbitz-candidate') ? prevPool.innerHTML : '';
      // Backup global: S&D de algunos colores (ej. Violeta) vuelve vacío y puede pisar el DOM
      if (bridgeRecHtml) {
        window.__lopJibbitzBridgeHtml = bridgeRecHtml;
      }

      oldInfo.innerHTML = newInfo.innerHTML;

      var nextComplementary = oldInfo.querySelector('.complementary-element');
      if (nextComplementary && prevWasVisible) {
        nextComplementary.style.display = '';
        var nextRec = nextComplementary.querySelector('product-recommendations');
        var nextPool = nextComplementary.querySelector('.lop-complementary-jibbitz-pool');
        if (nextRec && bridgeRecHtml && !nextRec.querySelector('a[href*="/products/"]')) {
          nextRec.innerHTML = bridgeRecHtml;
          nextRec.dataset.lopJibbitzBridge = 'true';
        }
        if (nextPool) {
          nextPool.classList.add('is-ready');
          if (bridgePoolHtml && !nextPool.querySelector('.lop-jibbitz-candidate')) {
            nextPool.innerHTML = bridgePoolHtml;
            nextPool.dataset.lopJibbitzRandomized = 'true';
          }
        }
      }
      
      // IMPORTANTE: Re-aplicar el background container después de actualizar
      setTimeout(() => {
        const groupedElements = oldInfo.querySelectorAll('.grouped-element');
        const existingContainer = oldInfo.querySelector('.custom-background-container');
        
        if (groupedElements.length > 0 && !existingContainer) {
          // Crear el contenedor si no existe
          const container = document.createElement('div');
          container.className = 'custom-background-container';
          
          const firstElement = groupedElements[0];
          if (firstElement && firstElement.parentNode) {
            firstElement.parentNode.insertBefore(container, firstElement);
            
            groupedElements.forEach(element => {
              container.appendChild(element);
            });
            
            console.log('[product.js] Background container re-aplicado después del cambio');
          }
        }
        
        // Respetar open/cerrado del markup Liquid (Theme editor).
        // No forzar todos abiertos: generaba inconsistencia vs carga inicial.
      }, 100);
    }

    // Reemplazar formulario de producto completo
    var newProductForm = tempDiv.querySelector('.product-form');
    var oldProductForm = document.querySelector('.product-form');
    if (newProductForm && oldProductForm) {
      oldProductForm.innerHTML = newProductForm.innerHTML;
    }
  }

  function initializeNewElements(tempDiv) {
    // 1. Primero, asegurar que los datos de variantes estén disponibles
    setupVariantData(tempDiv);
    
    // 2. Re-inicializar variant-selects
    initializeVariantSelects();
    
    // 3. Re-inicializar product-slider
    initializeProductSlider();
    
    // 4. Re-inicializar product-form
    initializeProductForm();
    
    // 5. Volver a activar los swatches
    activarSwatchesAgrupados();

    // 5b. Cargar swatches faltantes que Liquid no pudo resolver (límite all_products)
    if (window.cargarSwatchesFaltantes) {
      setTimeout(function() {
        window.cargarSwatchesFaltantes();
        // Re-activar click handlers en los swatches recién creados
        setTimeout(function() { activarSwatchesAgrupados(); }, 500);
      }, 100);
    }
    
    // 6. IMPORTANTE: Re-procesar cucardas y precios tachados después del cambio de color
    setTimeout(function() {
      var productDetail = document.querySelector('.thb-product-detail.product');
      if (productDetail) {
        // Remover flags de procesamiento para permitir reprocesar
        productDetail.removeAttribute('data-cucardas-procesadas');
        productDetail.removeAttribute('data-descuento-aplicado');
        
        // Llamar a la función de procesamiento de descuentos ficticios si existe
        if (typeof procesarDescuentosFicticiosProducto === 'function') {
          procesarDescuentosFicticiosProducto();
        } else if (window.procesarDescuentosFicticiosProducto) {
          window.procesarDescuentosFicticiosProducto();
        }
      }
    }, 200);
  }

  function setupVariantData(tempDiv) {
    // Preferir el JSON real de variantes (evitar talles/agrupador/otros scripts)
    var variantJsonScript = tempDiv.querySelector('.product-variants-json')
      || tempDiv.querySelector('variant-selects script[type="application/json"]');

    if (variantJsonScript) {
      var variantSelects = document.querySelector('variant-selects');
      if (variantSelects) {
        var existingScript = variantSelects.querySelector('.product-variants-json')
          || variantSelects.querySelector('script[type="application/json"]');
        if (existingScript) {
          existingScript.remove();
        }
        variantSelects.appendChild(variantJsonScript.cloneNode(true));
        try {
          var parsed = JSON.parse(variantJsonScript.textContent);
          if (Array.isArray(parsed)) {
            variantSelects.variantData = parsed;
          } else {
            variantSelects.variantData = null;
          }
        } catch (e) {
          variantSelects.variantData = null;
        }
      }
    }
  }

  function initializeVariantSelects() {
    document.querySelectorAll('variant-selects').forEach(variantSelect => {
      // Limpiar datos anteriores
      variantSelect.variantData = null;
      variantSelect.tallesData = null;
      
      // Verificar que todos los elementos necesarios existen
      const productWrapper = variantSelect.closest('.thb-product-detail');
      if (!productWrapper) {
        console.warn('Product wrapper no encontrado');
        return;
      }

      const productSlider = productWrapper.querySelector('.product-images');
      
      // Re-asignar propiedades
      variantSelect.productWrapper = productWrapper;
      variantSelect.productSlider = productSlider;
      
      // Verificar que el JSON de variantes existe
      const variantJson = variantSelect.querySelector('[type="application/json"]');
      if (!variantJson) {
        console.error('JSON de variantes no encontrado en variant-selects');
        return;
      }

      try {
        // Verificar que el JSON es válido
        const variantData = JSON.parse(variantJson.textContent);
        if (!Array.isArray(variantData)) {
          console.error('Datos de variantes no son un array válido');
          return;
        }
        
        // Re-cargar datos de género si es necesario
        variantSelect.hasGenderSwitch = variantSelect.dataset.hasGenderSwitch === 'true';
        if (variantSelect.hasGenderSwitch) {
          // No forzar género aquí, permitir que se detecte automáticamente
          variantSelect.currentGender = null;
          variantSelect.loadGenderData();
          variantSelect.initGenderSwitch();
          variantSelect.hideOriginalGenderOptions();
        }
        
        // Re-ejecutar connectedCallback manualmente
        if (typeof variantSelect.connectedCallback === 'function') {
          variantSelect.connectedCallback();
        }
        
        // Forzar actualización inicial después de un breve delay
        setTimeout(() => {
          if (typeof variantSelect.onVariantChange === 'function') {
            variantSelect.onVariantChange();
          }
        }, 100);
        
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    });
  }

  function initializeProductSlider() {
    document.querySelectorAll('product-slider').forEach(slider => {
      // Verificar que el thumbnail container existe
      const productContainer = slider.closest('.thb-product-detail');
      if (!productContainer) {
        console.warn('Product container no encontrado para slider');
        return;
      }

      const thumbnailContainer = productContainer.querySelector('.product-thumbnail-container');
      if (!thumbnailContainer) {
        console.warn('Thumbnail container no encontrado');
        return;
      }

      // Re-ejecutar connectedCallback
      try {
        if (typeof slider.connectedCallback === 'function') {
          slider.connectedCallback();
        }
      } catch (e) {
        console.warn('Error inicializando slider:', e);
      }
    });
  }

  function initializeProductForm() {
    document.querySelectorAll('product-form').forEach(form => {
      // Re-ejecutar connectedCallback
      try {
        if (typeof form.connectedCallback === 'function') {
          form.connectedCallback();
        }
      } catch (e) {
        console.warn('Error inicializando form:', e);
      }
    });
  }

  // Inicializar por primera vez
  activarSwatchesAgrupados();
});